// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_9B","credits":"e_-B","badgeContainer":"e_aC","badge":"e_bC"};